import i18n from 'i18next';
import moment from 'moment';
import 'moment/locale/ar';
moment.locale('ar');

export function getOfficeName(user) {
  if(user?.office && user?.office.name) {
    return user?.office.name;
  } else {
    return user?.name;
  }
}

export function getPropertyForString(property_for) {
  switch (property_for) {
    case 'rent':
      return 'للإيجار';
      break;

    case 'sale':
      return 'للبيع';
      break;

    case 'exchange':
      return 'للبدل';
      break;

    default:
      return '';
      break;
  }
}

export function dateDisplay(date) {
  const originalDate = date;
  const dateObj = moment(originalDate);

  // Add one month
  const dateOneMonthLater = dateObj.add(1, 'month');

  // Set locale to Arabic and format
  const formattedDate = dateOneMonthLater.locale('ar').format('D MMMM YYYY');

  // Replace Western Arabic numerals with Eastern Arabic numerals
  // Moment.js's Arabic locale already handles this for the month and year,
  // but for the day number, it might still use Western Arabic numerals.
  // This step ensures all numbers are Eastern Arabic.
  const easternArabicFormattedDate = formattedDate
    .replace(/0/g, '٠')
    .replace(/1/g, '١')
    .replace(/2/g, '٢')
    .replace(/3/g, '٣')
    .replace(/4/g, '٤')
    .replace(/5/g, '٥')
    .replace(/6/g, '٦')
    .replace(/7/g, '٧')
    .replace(/8/g, '٨')
    .replace(/9/g, '٩');

  return easternArabicFormattedDate;
}

export function nl2br(text) {
  if (!text) return '';
  return text.replace(/\n/g, '<br/>');
}

export function generateKey(length = 8) {
  const chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  let key = "";
  for (let i = 0; i < length; i++) {
    key += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return key;
}

export function printPropertyDescription(description = '') {
  if(!description) return '';
  if(window.innerWidth < 768) {
    return description?.substring(0, 80) + (description?.length > 80 ? '...' : '');
  } else {
    return description?.substring(0, 150) + (description?.length > 150 ? '...' : '');
  }
}

export function getOfficePhoneNumber(user) {
  if(user?.office && user?.office.phone_number) {
    return (user?.country_code || '') + user?.office.phone_number;
  } else {
    return (user?.country_code || '') + user?.phone_number;
  }
}

export function getOfficePhoneNumberWithoutCountryCode(user) {
  if(user?.office && user?.office.phone_number) {
    return user?.office.phone_number;
  } else {
    return user?.phone_number;
  }
}

export function getOfficeWhatsAppNumber(user) {
  if(user?.office && user?.office.whatsapp_number) {
    return (user?.country_code || '') + user?.office.whatsapp_number;
  } else {
    return (user?.country_code || '') + user?.phone_number;
  }
}

export function handleInstagramLink(link) {
  if(!link) return null;

  if(link.startsWith('http://') || link.startsWith('https://')) {
    return link;
  }

  if(link.startsWith('www.')) {
    return 'https://' + link;
  }

  if(link.startsWith('instagram.com/')) {
    return 'https://' + link;
  }

  return 'https://www.instagram.com/' + link;
}

export function handleTikTokLink(link) {
  if(!link) return null;

  if(link.startsWith('http://') || link.startsWith('https://')) {
    return link;
  }

  if(link.startsWith('www.')) {
    return 'https://' + link;
  }

  if(link.startsWith('tiktok.com/')) {
    return 'https://' + link;
  }

  if(link.startsWith('@')) {
    link = link.substring(1);
  }

  return 'https://www.tiktok.com/@' + link;
}

export function tField(data, base) {
  const lang = (i18n.language || 'en')
  return data[`${base}_${lang}`];
}

export function printPrice(price) {
  if(!price) return '';
  return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}